import { render, staticRenderFns } from "./iatCategoryHeader.vue?vue&type=template&id=5800ae27"
import script from "./iatCategoryHeader.vue?vue&type=script&lang=js"
export * from "./iatCategoryHeader.vue?vue&type=script&lang=js"
import style0 from "./iatCategoryHeader.vue?vue&type=style&index=0&id=5800ae27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports